import { fetchWrapper, objectToQueryParams, handleDownloadLocalFile } from '../utils';

export class school {
  static baseUrl = process.env.REACT_APP_BASE_API + 'school/users';

  static async create(form) {
    return await fetchWrapper.post(this.baseUrl, form);
  }

  /* STUDENTS */
  static async createStudent(form) {
    const url = `${this.baseUrl}/students/create`;
    return await fetchWrapper.post(url, form);
  }

  static async updateStudent(form) {
    const url = `${this.baseUrl}/students/update`;
    return await fetchWrapper.post(url, form);
  }

  static async createStudentInBulk(form) {
    const url = `${this.baseUrl}/students/importexcel`;
    return await fetchWrapper.post(url, form);
  }

  static async destroyStudent(stutendId) {
    const url = `${this.baseUrl}/students/destroy`
    return await fetchWrapper.post(url, { id: stutendId })
  }


  /* USERS */
  static async findAll(filters) {
    const url = `${this.baseUrl}?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }


  static async findStudents(filters) {
    const url = `${this.baseUrl}/students?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async findTeachers(filters) {
    const url = `${process.env.REACT_APP_BASE_API}school/admin/getProfessors`
    return await fetchWrapper.post(url, filters)
  }

  static async update(form) {
    return await fetchWrapper.put(this.baseUrl, form);
  }

  static async destroy(form) {
    return await fetchWrapper.delete(this.baseUrl, form);
  }


  /* SELECTS */
  static async getSelects(filters) {
    const url = `${this.baseUrl}/selects?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }


  /* USER PARENTS */
  static async createParentsInBuk(form) {
    const url = `${this.baseUrl}/parents/importexcel`;
    return await fetchWrapper.post(url, form);
  }

  static async dowloadFile(filePath) {
    return await handleDownloadLocalFile(filePath);
  }
}
